module.exports = __webpack_public_path__ + "static/img/tutoriales sin texto utopie-10.2a6c7910.jpg";